module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-in-this-price-image-1-f552235b8e8c95d1e322404c86deb42f.png";